import { render, staticRenderFns } from "./PerformanceHeader.vue?vue&type=template&id=d864058a&scoped=true&"
import script from "./PerformanceHeader.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PerformanceHeader.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PerformanceHeader.vue?vue&type=style&index=0&id=d864058a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d864058a",
  null
  
)

export default component.exports